// The number of the display row of the orderbook on PC and mobile.
export const PC_DISPLAY_ROW = 6
export const MOBILE_DISPLAY_ROW = 20

// The maximum number of the view single side of the orderbook.
export const MAXIMUM_SINGLE_SIDE_VIEW = 30
